import { RestApi } from '../restApi';

import type { SettingsRESTResponse } from './types';
import type { AxiosError, AxiosResponse } from 'axios';

export class SettingsApi extends RestApi {
  static async getSettings(): Promise<SettingsRESTResponse | null> {
    try {
      const response: AxiosResponse<SettingsRESTResponse> = await this.woofApi.get('/v1/settings');

      return { ...response.data };
    } catch (error) {
      return this.handleError(error as AxiosError);
    }
  }
}
